import { SafetyReportInternalType, SafetyReportType } from './types'

export const SAFETY_REPORT_INTERNAL_TYPE_TO_LABEL: Record<SafetyReportInternalType, string> = {
  [SafetyReportInternalType.UserProfile]: 'Inappropriate user profile',
  [SafetyReportInternalType.InformationSharing]: 'Breaking information-sharing protocols',
  [SafetyReportInternalType.UnderAge]: 'Underage site usage',
  [SafetyReportInternalType.PotentialGrooming]: 'Suspected grooming',
  [SafetyReportInternalType.NotSafetyIssue]: 'Not a safety issue',
  [SafetyReportInternalType.FlaggedOneOnOneSession]: 'Flagged 1:1 session',
  [SafetyReportInternalType.Spam]: 'Spam',
  [SafetyReportInternalType.RudeShocking]: 'Overtly rude/shocking behavior',
  [SafetyReportInternalType.InappropriatelyPersonal]: 'Inappropriately personal behavior',
  [SafetyReportInternalType.Insensitivity]: 'Bias or insensitivity',
  [SafetyReportInternalType.UnintentionalDisruption]:
    'Rude or disruptive behavior without evidence of malice',
  [SafetyReportInternalType.Bullying]: 'Harassment or bullying',
  [SafetyReportInternalType.Benign]: 'Benign',
  [SafetyReportInternalType.Duplicate]: 'Duplicate',
  [SafetyReportInternalType.Other]: 'Other',
  [SafetyReportInternalType.ZoomSessionRemoval]: 'Zoom Session Removal',
  [SafetyReportInternalType.PlatformAbuse]: 'Platform Abuse',
}

export const URGENT_PLATFORM_FEEDBACK_TYPES: SafetyReportType[] = [
  SafetyReportType.Spam,
  SafetyReportType.Harassment,
  SafetyReportType.InappropriateBehavior,
]

export const SAFETY_REPORT_TYPES = [
  SafetyReportType.InappropriateBehavior,
  SafetyReportType.Harassment,
  SafetyReportType.LeakedPersonalInfo,
  SafetyReportType.ContentQuality,
  SafetyReportType.Spam,
  SafetyReportType.Other,
]

export const SAFETY_REPORT_TYPE_TO_LABEL: Record<SafetyReportType, string> = {
  [SafetyReportType.InappropriateBehavior]: 'Trolling / inappropriate behavior',
  [SafetyReportType.Harassment]: 'Other behavior that made me uncomfortable',
  [SafetyReportType.LeakedPersonalInfo]: 'Personal information solicited or shared',
  [SafetyReportType.ContentQuality]: 'Questionable session content',
  [SafetyReportType.Spam]: 'Spam',
  [SafetyReportType.Other]: 'Something else',
}
